var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container toc"},[_c('page-title',[_vm._v("Table of Contents")]),_c('div',{staticClass:"content"},[_c('MenuItems')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }